export default __webpack_public_path__ + "static/media/new_big_lg.ae7b830c.PNG";